import React from "react";
import Select from "react-select";
import Datepicker from "react-datepicker";
import Moment from "moment";
import Toaster from "toastr";
import FloatInput from "../../common/floatInput";
import { permissioned } from "../../common/permissionedHoc";
import Constants from "../../../configurations/constants";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import ErrorLabel from "../../common/errorLabel";
import ArbiterApi from "../../../api/ArbiterApi";

class NewClaimTxnFilter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      txnType: null,
      identifier: "",
      fromDate: Moment()
        .subtract(Constants.MAX_DATE_RANGE_DAYS, "days")
        .startOf("day"),
      toDate: Moment().endOf("day"),
      stan: "",
      retrievalReferenceNumber: "",
      terminalId: "",
      toAccount: "",
      validity: {
        identifier: false,
        fromDate: true,
        toDate: true,
        dateRange: true,
        txnType: false
      },
      transactionGroups: [],
      currentTransactionGroup: null,
      transactionGroupFilters: [],
      channels: [],
      selectedChannel: null,
      searchButtonDisabled: true,
      touchedForm: false
    };
    this.onTxnTypeChange = this.onTxnTypeChange.bind(this);
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.onFromDateChange = this.onFromDateChange.bind(this);
    this.onToDateChange = this.onToDateChange.bind(this);
    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.onTxnIdentifierChange = this.onTxnIdentifierChange.bind(this);
    this.onChannelChange = this.onChannelChange.bind(this);
  }
  componentDidMount() {
    ArbiterApi.getTransactionGroups()
      .then(response => {
        let data = response.data;
        let groups = data || [];
        //Map groups to support the select field e.g add label and value properties
        groups = groups.map(item => {
          item.label = item.name;
          item.value = item.name;
          return item;
        });
        this.setState({ transactionGroups: groups });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_TRANSACTION_GROUPS}`
        ]);
      });
  }
  componentDidUpdate(prevProps, prevState) {
    //Set Search button to be enabled (Initial State = 'disabled')
    if (
      this.state.searchButtonDisabled &&
      prevState.identifierType === this.state.identifierType
    )
      //Select txn type was not the control value  changed
      this.setState({ searchButtonDisabled: false });
  }
  onChannelChange(selectedChannel) {
    let filters = [];
    //Generate array filters
    let filterGroupSize = 4;
    if (selectedChannel && selectedChannel.additionalParameters) {
      let numberOfFilterGroups = Math.ceil(
        selectedChannel.additionalParameters.length / filterGroupSize
      );
      for (let i = 0; i < numberOfFilterGroups; i++) {
        filters.push(
          selectedChannel.additionalParameters.slice(
            filterGroupSize * i,
            filterGroupSize * (i + 1)
          )
        );
      }
    }
    //If  empty channel
    let validityState = this.setValidityAndReturn(
      "selectedChannel",
      selectedChannel ? !!selectedChannel.value : false
    );
    this.setState({ validity: validityState });
    this.setState({ transactionGroupFilters: filters, selectedChannel });
  }

  onTxnIdentifierChange(event) {
    let clearVal = event.target.value;
    let val =
      event.target.name === Constants.TXN_IDENTIFIER_PAN.name
        ? Util.maskPan(clearVal)
        : clearVal;

    let valid = false;

    valid = this.validateInputField(event.target.name, val, false);

    let stateUpdate = {
      identifier: val,
      validity: this.setValidityAndReturn("identifier", valid)
    };
    this.setState(stateUpdate);
  }
  onTextInputChange(event) {
    let value = event.target.value;
    let val =
      event.target.name === Constants.TXN_IDENTIFIER_PAN.name
        ? Util.maskPan(value)
        : value;
    let valid = this.validateInputField(event.target.name, val, false);
    let stateUpdate = {};
    stateUpdate[event.target.name] = val;
    stateUpdate.touchedForm = true;
    stateUpdate.validity = this.setValidityAndReturn(event.target.name, valid);

    this.setState(stateUpdate);
  }
  onFromDateChange(date) {
    //Set the 'toDate' to maximum date. Set validity for dates to 'true'
    let maxDate = date.clone();

    maxDate.add(Constants.MAX_DATE_RANGE_DAYS, "days").endOf("day");
    let validity = this.setValidityAndReturn("fromDate", true);
    validity.dateRange = true;
    validity.toDate = true;
    this.setState({
      fromDate: date.startOf("day"),
      toDate: maxDate,
      validity: validity,
      touchedForm: true
    });
  }
  onToDateChange(date) {
    let valid = date != null;
    let validDateRange = true;

    //Validate that from date isn't less than specified  month range
    if (this.state.fromDate) {
      let maxDate = date.clone();
      maxDate.subtract(Constants.MAX_DATE_RANGE_DAYS, "days").startOf("day");
      valid = date.unix() >= this.state.fromDate.unix();
      validDateRange = maxDate.unix() <= this.state.fromDate.unix();
    }
    let validity = this.setValidityAndReturn("toDate", valid);
    validity.dateRange = validDateRange;

    this.setState({
      toDate: date.endOf("day"),
      validity: validity,
      touchedForm: true
    });
  }
  onSearchHandler() {
    //TODO: validate control values
    //If  empty currentTransactionGroup
    if (!this.state.currentTransactionGroup) {
      let validityState = this.setValidityAndReturn(
        "currentTransactionGroup",
        !!this.state.currentTransactionGroup
      );
      this.setState({ validity: validityState });
      return;
    }

    //If  empty channel
    if (!this.state.selectedChannel) {
      let validityState = this.setValidityAndReturn(
        "selectedChannel",
        !!this.state.selectedChannel
      );
      this.setState({ validity: validityState });
      return;
    }

    //Build Params
    let params = {};
    let currentTransactionGroup = this.state.currentTransactionGroup;
    let selectedChannel = this.state.selectedChannel;

    //Additional Params
    if (selectedChannel.additionalParameters) {
      selectedChannel.additionalParameters.forEach(param => {
        let val = this.state[param];
        if (val) params[param] = val;
      });
    }

    //Query Params
    params[selectedChannel.customerReference] = this.state.identifier;

    //date params
    params.startDate = this.state.fromDate
      ? this.state.fromDate.format(Constants.DATE_FORMAT_LONG)
      : null;
    params.endDate = this.state.toDate
      ? this.state.toDate.endOf("day").format(Constants.DATE_FORMAT_LONG)
      : null;

    this.props.onSearchHandler &&
      this.props.onSearchHandler(
        currentTransactionGroup.name,
        selectedChannel.value,
        params
      );
  }
  onTxnTypeChange(event) {
    let filters = [];
    this.clearAdvancedInputs();

    //Map channels
    let channels =
      !event || !event.channels
        ? []
        : Object.keys(event.channels).map(c => {
            let channel = event.channels[c];
            channel.label = c;
            channel.value = c;
            return channel;
          });

    //Select first channel if only one chennel in the list
    let selectedChannel = channels.length === 1 ? channels[0] : null;

    //Generate array filters
    let filterGroupSize = 4;

    if (selectedChannel && selectedChannel.additionalParameters) {
      let numberOfFilterGroups = Math.ceil(
        selectedChannel.additionalParameters.length / filterGroupSize
      );
      for (let i = 0; i < numberOfFilterGroups; i++) {
        filters.push(
          selectedChannel.additionalParameters.slice(
            filterGroupSize * i,
            filterGroupSize * (i + 1)
          )
        );
      }
    }
    let validity = this.setValidityAndReturn(
      "txnType",
      event ? !!event.value : false
    );
    validity.identifier = false;
    filters.forEach((filterArray, index)=> {
      filterArray.forEach(filter => {
        validity[filter] = false;
      })
    })
    this.setState({
      txnType: event ? event.name : "",
      currentTransactionGroup: event,
      transactionGroupFilters: filters,
      identifier: "",
      selectedChannel: selectedChannel,
      channels: channels,
      category: null,
      validity,
      touchedForm: true
    });
  }

  render() {
    return (
      <form
        onSubmit={e => {
          this.onSearchHandler();
          e.preventDefault();
          return false;
        }}
      >
        <div>
          <div className="row">
            <div className="col-md-10">
              <div className="row filters">
                <div className="col-md-3">
                  <label className="input-control-label required">
                    Transaction group
                  </label>
                  <Select
                    name="txnType"
                    placeholder="Tran. Group"
                    value={this.state.txnType}
                    options={this.state.transactionGroups}
                    onChange={this.onTxnTypeChange}
                  />
                  {this.state.touchedForm &&
                    !this.state.validity.txnType && (
                      <ErrorLabel message={Messages.INVALID_TXN_TYPE} />
                    )}
                </div>
                <div className="col-md-3">
                  <label className="input-control-label required">
                    Channel
                  </label>
                  <Select
                    name="channel"
                    placeholder="Channel"
                    value={this.state.selectedChannel}
                    options={this.state.channels}
                    onChange={this.onChannelChange}
                  />
                  {this.state.touchedForm &&
                    !this.state.validity.txnType && (
                      <ErrorLabel message={Messages.INVALID_CHANNEL} />
                    )}
                </div>

                <div className=" col-md-3">
                  <span className="datepicker-wrapper">
                    <label className="input-control-label required">From</label>
                    <Datepicker
                      onChange={this.onFromDateChange}
                      allowSameDay={true}
                      maxDate={Moment()}
                      className="form-control"
                      id="fromDate"
                      placeHolderText="From Date"
                      disabledKeyboardNavigation
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      readOnly
                      dateFormat={Constants.DATE_FORMAT}
                      selected={this.state.fromDate}
                    />
                  </span>
                  <br />
                  {(!this.state.validity.fromDate ||
                    !this.state.validity.dateRange) && (
                    <ErrorLabel
                      message={
                        !this.state.validity.dateRange
                          ? Messages.INVALID_DATE_RANGE
                          : Messages.INVALID_START_DATE
                      }
                    />
                  )}
                </div>

                <div className=" col-md-3">
                  <span className="datepicker-wrapper">
                    <label className="input-control-label required">To</label>
                    <Datepicker
                      onChange={this.onToDateChange}
                      id="toDate"
                      className="form-control"
                      dateFormat={Constants.DATE_FORMAT}
                      placeHolderText="To Date"
                      disabledKeyboardNavigation
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      readOnly
                      dropdownMode="select"
                      minDate={this.state.fromDate}
                      maxDate={
                        this.state.fromDate
                          ? this.state.fromDate
                              .clone()
                              .add(Constants.MAX_DATE_RANGE_DAYS, "days")
                          : Moment()
                      }
                      selected={this.state.toDate}
                    />
                  </span>
                  <br />
                  {(!this.state.validity.toDate ||
                    !this.state.validity.dateRange) && (
                    <ErrorLabel
                      message={
                        !this.state.validity.dateRange
                          ? Messages.INVALID_DATE_RANGE
                          : Messages.INVALID_END_DATE
                      }
                    />
                  )}
                </div>
              </div>
              <h5 className="text-info bold">
                Please enter at least one identifier to proceed
              </h5>
              <div className="row filters p-0-15">
                <div className="panel panel-default">
                  <div className="panel-body p-15-0">
                    <div className="col-md-3">
                      <label className="input-control-label">
                        {this.state.selectedChannel
                          ? `${Util.regularFormString(
                              this.state.selectedChannel.customerReference
                            )}`
                          : "Tran. Identifier"}
                      </label>
                      <FloatInput
                        id="identifier"
                        name={
                          this.state.selectedChannel
                            ? this.state.selectedChannel.customerReference
                            : "identifier"
                        }
                        value={this.state.identifier}
                        onChange={this.onTxnIdentifierChange}
                        placeholder={
                          this.state.selectedChannel
                            ? `${Util.regularFormString(
                                this.state.selectedChannel.customerReference
                              )}`
                            : "Tran. Identifier"
                        }
                        showError={
                          this.state.touchedForm &&
                          this.state.identifier &&
                          !this.state.validity.identifier
                        }
                        errorMessage={` ${
                          Messages.INVALID_IDENTIFIER
                        } ${Util.regularFormString(
                          this.state.selectedChannel
                            ? this.state.selectedChannel.customerReference
                            : "identifier"
                        )}`}
                      />
                    </div>
                    {this.state.transactionGroupFilters.map(
                      (filterArray, index) => (
                        <span key={index}>
                          {filterArray.map(filter => {
                            return (
                              <div key={filter} className="col-md-3">
                                <label className="input-control-label">
                                  {Util.regularFormString(filter)}
                                </label>
                                <FloatInput
                                  value={this.state[filter]}
                                  onChange={this.onTextInputChange}
                                  id={filter}
                                  name={filter}
                                  placeholder={Util.regularFormString(filter)}
                                  showError={
                                    this.state.touchedForm &&
                                    this.state[filter] &&
                                    !this.state.validity[filter]
                                  }
                                  errorMessage={` ${
                                    Messages.INVALID_IDENTIFIER
                                  } ${filter}`}
                                />
                              </div>
                            );
                          })}
                        </span>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <button
                disabled={
                  this.state.searchButtonDisabled || !this.isValidForm()
                }
                className="btn btn-primary btn-block mt-20"
                type="submit"
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }

  isValidForm() {
    if (!this.state.touchedForm) return false;
    let isValid = true;
    for (let i in this.state.validity) {
      isValid = isValid && this.state.validity[i];
    }
    return isValid || this.checkIfIdentifierExists();
  }

  returnValidityFilters() {
    let filterValidities = {};
    if (
      this.state.transactionGroupFilters &&
      this.state.transactionGroupFilters.length
    ) {
      for (let i = 0; i < this.state.transactionGroupFilters[0].length; i++) {
        filterValidities[this.state.transactionGroupFilters[0][i]] =
          this.state.validity[this.state.transactionGroupFilters[0][i]] ||
          false;
      }
    }
    return { ...filterValidities, identifier: this.state.validity.identifier };
  }

  checkIfIdentifierExists() {
    let isValidFilter = false;
    let filterValidity = this.returnValidityFilters();
    for (let i in filterValidity) {
      isValidFilter = isValidFilter || filterValidity[i];
    }
    return isValidFilter;
  }

  setValidityAndReturn(fieldId, validity) {
    let validityState = Object.assign({}, this.state.validity);
    validityState[fieldId] = validity;
    return validityState;
  }
  clearAdvancedInputs() {
    let validity = Object.assign({}, this.state.validity);
    let stateUpdate = {};
    let selectedChannel = this.state.selectedChannel;
    if (selectedChannel) {
      selectedChannel.additionalParameters &&
        selectedChannel.additionalParameters.forEach(filter => {
          validity[filter] = true;
          stateUpdate[filter] = "";
        });
    }
    stateUpdate.validity = validity;
    this.setState(stateUpdate);
  }

  validateInputField(field, value, allowEmpty) {
    let isValid = true;

    if (!value && allowEmpty) return isValid;

    switch (field) {
      case Constants.TXN_IDENTIFIER_PAN.name:
        isValid = Constants.REG_EXPR_VALID_PAN.test(value);
        break;
      case Constants.TXN_IDENTIFIER_PAYCODE.name:
        isValid = Constants.REG_EXPR_VALID_DIGITS.test(value);
        break;
      default:
        isValid = !!value;
    }

    return isValid;
  }
}

export default permissioned(NewClaimTxnFilter);



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/newClaim/newClaimTxnFilter.js